import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDatepickerConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';

import {
  BlankValidator,
  ConfiguracoesProjeto,
  CPFValidator,
  DateValidator,
  MaskManager,
  NbpInfoComponent,
  ParametrosService,
} from '../../../shared';
import { ConsumidorFormatter, ConsumidorModel, ConsumidorService } from '../shared/';
import { StatusRequisicao } from '../../../shared/model/status-requisicao';
import { RecaptchaSafety } from '../../../shared/security/RecaptchaSafety';
import { ConsumidorReceitaFederalService } from '../shared/consumidor-receita-federal-service';
import { FiltroConsumidorReceitaFederal } from '../../../shared/filter/filtro-consumidor-receita-federal';
import { StatusCpfCidadao } from '../../../shared/model/status-cpf-cidadao.model';

interface IValidation {
  [key: string]: boolean;
}

@Component({
  selector: 'app-consumidor-cadastrar',
  templateUrl: './consumidor-cadastrar.component.html',
  styleUrls: ['./consumidor-cadastrar.component.css']
})
export class ConsumidorCadastrarComponent implements OnInit {
  consumidorForm: FormGroup;
  validarForm = false;
  consumidorModel: ConsumidorModel = new ConsumidorModel();
  validCPF = true;
  validRecaptcha = false;

  public mensagemModalImpedido: string = null;

  public maskCPF = MaskManager.CPF;
  public maskData = MaskManager.DATA;
  public recaptcha: string;
  public configuracao: ConfiguracoesProjeto;

  public mensagemErro: string = "";

  public useRecaptcha = true;

  public formErrors = {
    cpf: [],
    dataNascimento: [],
    nomeMae: []
  };

  public validationMessages = {
    cpf: {
      required: 'O Campo CPF é de preenchimento obrigatório.',
      cpfInvalido: 'Informe um CPF válido.',
      cpfJaCadastrado: 'Informe um CPF não cadastrado na Campanha, ou realize seu login com a senha já cadastrada.',
      cpfCadastrado: 'Informe um CPF não cadastrado na Campanha, ou realize seu login com a senha já cadastrada.',
      cpfBloqueado: 'Cidadão com CPF bloqueado para uso do sistema.'
    },
    dataNascimento: {
      required: 'O Campo Data de Nascimento é de preenchimento obrigatório.',
      pattern: 'Data de Nascimento inválida. Informe uma Data de Nascimento válida.',
      brazilianDate: 'Data de Nascimento inválida. Informe uma Data de Nascimento válida.',
      dataInvalida: 'O Campo Data de Nascimento não pode ser maior que a data atual',
      dataIgualAtual: 'O Campo Data de Nascimento não pode ser igual a data atual.'
    },
    nomeMae: {
      required: 'O Campo Nome da Mãe é de preenchimento obrigatório.'
    }
  };

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly consumidorService: ConsumidorService,
    private readonly config: NgbDatepickerConfig,
    private readonly parametrosService: ParametrosService,
    private readonly ngbModalService: NgbModal,
    private readonly consumidorReceitaFederalService: ConsumidorReceitaFederalService,
  ) {
    // customize default values of datepickers used by this component tree
    config.minDate = { year: 1900, month: 1, day: 1 };
    config.maxDate = { year: 2099, month: 12, day: 31 };
  }

  ngOnInit() {
    
    this.mensagemModalImpedido = null;

    this.configuracao = this.parametrosService.getConfiguracao();

    if(this.configuracao.ambiente == RecaptchaSafety.AmbienteUsoObrigatorioRecaptcha) {
      this.useRecaptcha = true;
      this.recaptcha = this.configuracao.recaptcha;
    }else{
      this.useRecaptcha = false;
      this.validRecaptcha = true;
    }

    this.consumidorModel = new ConsumidorModel();
    this.consumidorService.setConsumidorModelNovo(this.consumidorModel);

    this.consumidorForm = new FormGroup({
      cpf: new FormControl(
        this.consumidorModel.cpf,
        [Validators.required, CPFValidator.validaCPF.bind(this)],
        [this.validaCpfExiste.bind(this)]
      ),
      dataNascimento: new FormControl(
        this.consumidorModel.dataNascimento, 
        [Validators.required, DateValidator.validatorBirthDate.bind(this)]),

      nomeMae: new FormControl(this.consumidorModel.nomeMae, [Validators.required, BlankValidator.valid.bind(this)])
    });

    this.consumidorForm.valueChanges.subscribe(data => this.onValueChanged(data));

    this.MostrarMensagemRedirecionamentoBaGovBr();
    this.ResetarVariaveisLogoutBaGovBr();
  }

  validaCpfExiste(control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    const cpf = control.value.replace(/\.|\-|\_/g, '');

    const q = new Promise<IValidation>((resolve, reject) => {
      this.consumidorService.getStatusCPF(cpf).subscribe(data => {
        this.mensagemModalImpedido = null;

      let dataResult = data as StatusCpfCidadao;

        switch (dataResult.statusCpf) {
          case 2:
            this.formErrors.cpf.push(this.validationMessages.cpf.cpfBloqueado);
            resolve({ cpfBloqueado: true });
            break;
          case 3:
            this.mensagemModalImpedido = 'Cidadão com CPF impedido para participação dos sorteios na Campanha NPB.';
            resolve(null);
            break;
          case 4:
          case 5:
            this.formErrors.cpf.push(this.validationMessages.cpf.cpfCadastrado);
            resolve({ cpfCadastrado: true });
            break;
          default:
            resolve(null);
        }
      }, error => {

        let err = error as StatusRequisicao;
        this.mensagemErro = err.motivo;

      });
    });
    return q;
  }

  onSubmit() {
    this.consumidorModel.cpf = ConsumidorFormatter.formataString(this.consumidorForm.value['cpf']);
    this.consumidorModel.dataNascimento = ConsumidorFormatter.strDate2Date(this.consumidorForm.value['dataNascimento']);

    this.consumidorModel.nomeMae = this.consumidorForm.value['nomeMae'];

    // validar cidadao na receita federal
    var dataNascimentoReceita = ConsumidorFormatter.strDateWithoutHourAndSlash(this.consumidorForm.value['dataNascimento']);
    var filtro = new FiltroConsumidorReceitaFederal(this.consumidorModel.cpf, dataNascimentoReceita, this.consumidorModel.nomeMae);
    this.consumidorReceitaFederalService.validaSituacaoConsumidorReceitaFederal(filtro).subscribe((data) => {

      // caso o cidadao esteja validado na receita continuar fluxo
      this.consumidorService.setConsumidorModel(this.consumidorModel);

      if (this.mensagemModalImpedido) {
        const confirmModal = this.ngbModalService.open(NbpInfoComponent);
        confirmModal.componentInstance.info = this.mensagemModalImpedido;
        this.router.navigate(['/consumidor/cadastro_dados_adicionais']);
      }

      // adaptar para receber o nome retornado da API do BCadastro
      this.validarFormConsumidor(data.nomeCidadao);
    },
    (error: any) => {
      let err = error as StatusRequisicao; 
      this.mensagemErro = err.motivo;

    });

  }

  resolved(captchaResponse: string) {
    this.validRecaptcha = true;
  }

  private cpfInvalido() {
    this.formErrors.cpf = [];
    if (!this.consumidorForm.get('cpf').value) {
      this.formErrors.cpf.push(this.validationMessages.cpf.required);
    } else {
      this.formErrors.cpf.push(this.validationMessages.cpf.cpfInvalido);
    }
  }

  private cpfErro(error: any) 
  {
    if (error.message != null) {

      this.formErrors.cpf = [];
      this.validCPF = true;

    } else {

      this.formErrors.cpf = [error.message];
    }
  }

  private isDate(d: string): boolean {
    try {
      new Date(d);

      return true;
    } catch (error) {
      return false;
    }
  }

  validarFormConsumidor(nome: string) {
    this.consumidorModel.nomeMae = this.consumidorForm.value['nomeMae'];

    this.consumidorService.setConsumidorModel(this.consumidorModel);
    this.router.navigate(['/consumidor/cadastro_dados_adicionais'], {queryParams: {data: nome}, skipLocationChange: true});
  }

  onValueChanged(data?: any) {
    for (const campo in this.formErrors) {
      const control = this.consumidorForm.get(campo);

      this.formErrors[campo] = [];

      if (control && control.dirty && !control.valid) {
        const messages = this.validationMessages[campo];
        for (const key in control.errors) {
          if (messages[key]) {
            this.formErrors[campo].push(messages[key]);
          }
        }
      }
    }
  }

  LimparErros(event) { 
    this.mensagemErro = "";
  } 

   private MostrarMensagemRedirecionamentoBaGovBr() {
    if((localStorage.getItem('redirecionamento_cidadao_inexistente_logout_gov_br_cadastro') == "1") ||
       (localStorage.getItem('redirecionamento_cidadao_excluido_logout_gov_br_inicio') == "1")) {
       this.ApresentarMensagemInformativa('É necessário realizar o cadastro na Campanha NPB, pois você não está cadastrado ainda.');  
     }
    }

    public ApresentarMensagemInformativa(mensagem: string) {      
        const informeNovoCadastro = this.ngbModalService.open(NbpInfoComponent);
        informeNovoCadastro.componentInstance.info = mensagem;                
    }

    private ResetarVariaveisLogoutBaGovBr() {
      localStorage.setItem('redirecionamento_cidadao_inexistente_logout_gov_br_cadastro', "0");
    }
}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-cadastrar/consumidor-cadastrar.component.ts